var map = {
	"./en/Auth.json": 44616,
	"./en/Common.json": 4204,
	"./en/LeftNav.json": 18721,
	"./en/TicketCreate.json": 91347,
	"./en/TicketDetail.json": 98808,
	"./en/TicketList.json": 95020,
	"./en/TicketTools.json": 61605,
	"./zh-CN/Auth.json": 32940,
	"./zh-CN/LeftNav.json": 92575,
	"./zh-CN/TicketCreate.json": 26939,
	"./zh-CN/TicketDetail.json": 7793,
	"./zh-CN/TicketList.json": 64639,
	"./zh-CN/TicketTools.json": 15150,
	"./zh-CN/common.json": 28373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80378;